import { tenantSpecificConfig } from '../constants';
import { getSiteTenant } from '../tenant';

export const getGoToCartUrl = (currentTenant: string): string => {
  const { REACT_APP_ENVIRONMENT = 'production' } = process.env;
  const { businessUnit, tenant } = getSiteTenant(currentTenant);
  const { cartUrl } =
    tenantSpecificConfig[REACT_APP_ENVIRONMENT][businessUnit][tenant];
  return cartUrl;
};
